import React from 'react';
import PropTypes from 'prop-types';
import { Broadcast, Subscriber } from 'react-broadcast';

class EphemeralStore extends React.Component {
  state = this.props.initialState;
  reducer = this.props.reducer;
  actions = this.props.actions;
  
  dispatch = (action) => this.setState(prev => this.reduce(prev, action));
  getState = () => this.state;

  workers = Object.keys(this.props.workers).reduce((acc, name) => {
    acc[name] = this.props.workers[name](this.dispatch, this.getState);
    return acc;
  }, {});


  reduce = function reducer(state = this.state, action) {
    if (this.reducer.hasOwnProperty(action.type)) {
      return this.reducer[action.type](state, action)
    } else {
      return state
    }
  }

  mapTypes = () => {
    return Object.keys(this.props.reducer).reduce((acc, key) => {
      acc[key] = key;
      return acc;
    }, {})
  }

  getValue = () => ({ storage: this.state, types: this.mapTypes(), eDispatch: this.dispatch, actions: this.actions, workers: this.workers });
  
  render() {
    return (
      <Broadcast channel={this.props.channel} value={this.getValue()}>
        {this.props.children}
      </Broadcast>
    );
  }
}

EphemeralStore.propTypes = {
  initialState: PropTypes.object.isRequired,
  reducer: PropTypes.object.isRequired,
  channel: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  actions: PropTypes.object,
  workers: PropTypes.object,
};
export default EphemeralStore;

export function eConnect(channel) {
  return function connectRoot(Component) {
    return class connectClass extends React.Component {
      render() {
        return (
          <Subscriber channel={channel}>
            {data => <Component {...this.props} {...data} />}
          </Subscriber>
        );
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/EphemeralStore.jsx